import { api } from '@/lib/api-client';
import type { Conversation, ChatMessage } from './types';

export async function fetchConversations(page = 1, perPage = 50) {
    const res = await api.get<{ data: Conversation[]; meta: Record<string, number> }>(
        '/chat/conversations',
        { params: { page, per_page: perPage } },
    );
    return res.data;
}

export async function createConversation(title: string, capabilityRef: string) {
    const res = await api.post<Conversation>('/chat/conversations', {
        title,
        capability_ref: capabilityRef,
    });
    return res.data;
}

export async function getConversation(id: string) {
    const res = await api.get<{ conversation: Conversation; messages: ChatMessage[] }>(
        `/chat/conversations/${id}`,
    );
    return res.data;
}

export async function updateConversation(id: string, title: string, capabilityRef: string) {
    const res = await api.put(`/chat/conversations/${id}`, {
        title,
        capability_ref: capabilityRef,
    });
    return res.data;
}

export async function deleteConversation(id: string) {
    await api.delete(`/chat/conversations/${id}`);
}

export async function saveMessage(conversationId: string, msg: {
    id: string;
    role: string;
    content: unknown;
    metadata?: unknown;
}) {
    const res = await api.post(`/chat/conversations/${conversationId}/messages`, msg);
    return res.data;
}

export async function deleteMessage(conversationId: string, messageId: string, deleteBelow = false) {
    await api.delete(`/chat/conversations/${conversationId}/messages/${messageId}`, {
        params: { deleteBelow },
    });
}

export async function forkConversation(conversationId: string, atMessageId: string) {
    const res = await api.post<{ newConversationId: string }>(
        `/chat/conversations/${conversationId}/fork`,
        { atMessageId },
    );
    return res.data;
}
